export default "assets/images/icons/Flèche-e1f412bd.svg";